import React from 'react'

const FeatArtistsScreen = () => {
  return (
    <div>FeatArtistsScreen</div>
  )
}

export default FeatArtistsScreen